import { render, staticRenderFns } from "./SelectPage.vue?vue&type=template&id=8b26a992&scoped=true&"
import script from "./SelectPage.vue?vue&type=script&lang=js&"
export * from "./SelectPage.vue?vue&type=script&lang=js&"
import style0 from "./SelectPage.vue?vue&type=style&index=0&id=8b26a992&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b26a992",
  null
  
)

export default component.exports